import React from 'react';

import PropTypes from 'prop-types';

export default function IconSearch({ className }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 9.79297L14.8536 14.1465C15.0488 14.3418 15.0488 14.6584 14.8536 14.8536C14.6583 15.0489 14.3417 15.0489 14.1464 14.8536L9.79289 10.5001L10.5 9.79297Z"
        fill="#1F1F1F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 2C4.01472 2 2 4.01472 2 6.5C2 8.98528 4.01472 11 6.5 11C8.98528 11 11 8.98528 11 6.5C11 4.01472 8.98528 2 6.5 2ZM1 6.5C1 3.46243 3.46243 1 6.5 1C9.53757 1 12 3.46243 12 6.5C12 9.53757 9.53757 12 6.5 12C3.46243 12 1 9.53757 1 6.5Z"
        fill="#1F1F1F"
      />
    </svg>
  );
}

IconSearch.propTypes = {
  className: PropTypes.string,
};

IconSearch.defaultProps = {
  className: '',
};
